
import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css'
import Home from './pages/home'

function App() {
  return (
    <div className="App">
      <Home />
    </div>
  );
}

export default App;
